import { IconButton, Tooltip } from '@mui/material';
import { Save } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

export type SaveButtonProps = {
  onClick: () => void;
  disabled?: boolean;
};

export function SaveButton({ onClick, disabled }: SaveButtonProps) {
  const { t } = useTranslation('common');

  return (
    <Tooltip title={t('save')}>
      <span>
        <IconButton size='small' color='secondary' onClick={onClick} disabled={disabled}>
          <Save fontSize='small' />
        </IconButton>
      </span>
    </Tooltip>
  );
}
